<template>

    <m-edit1/>

    <m-n2-header v-bind='{...{"image":"https:\/\/api.cafen2.ir\/storage\/assets\/header-section-image.ed15f31b.png","alt":"cafe n2","buttonName":"\u062d\u0633\u0627\u0628 \u06a9\u0627\u0631\u0628\u0631\u06cc","buttonLink":"https:\/\/dash.cafen2.ir\/dashboard"},...{}}' :style='""' class="" ></m-n2-header><m-language-changer-1 v-bind='{...{},...{}}' :style='""' class="text-center mb-5" ></m-language-changer-1><m-products-302 v-bind='{...{"paginate":false,"perPage":35,"productCardName":"mProductCard208","showSpecifiedCardFeature":""},...{}}' :style='""' class="container" ></m-products-302><m-n2-contact-us v-bind='{...{"image":"https:\/\/api.cafen2.ir\/storage\/assets\/instagram.d8a39059.png","alt":"cafe n2"},...{}}' :style='""' class="" ></m-n2-contact-us><m-world-map v-bind='{...{},...{}}' :style='""' class="" >
                <template #default>default   </template>
                </m-world-map>

</template>

<script>
import mEdit1 from '@moeinmdn/miw-alpha-components/src/package/Tool/Edit/Edit1'
import {appendTagsToPage} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Seo";

import mN2Header from '@moeinmdn/miw-alpha-components/src/package/FancyComponent/N2Header'; import mLanguageChanger1 from '@moeinmdn/miw-alpha-components/src/package/Language/LanguageChanger/LanguageChanger1'; import mProducts302 from '@moeinmdn/miw-alpha-components/src/package/Product/Products/Products302/Products302'; import mN2ContactUs from '@moeinmdn/miw-alpha-components/src/package/FancyComponent/N2ContactUs'; import mWorldMap from '@moeinmdn/miw-alpha-components/src/package/FancyComponent/WorldMap';

export default {
    name: 'HomeView',
    components: {mEdit1, mN2Header,mLanguageChanger1,mProducts302,mN2ContactUs,mWorldMap },
    mounted() {
       if(this.$route.name === 'Home'){
           appendTagsToPage({}, 'home')
       }
    },
}
</script>


<style scoped>

</style>
